import CardWrapper from '../wrapper/card';
import EmailNotificationComponent from './email_notificaiton';
import { KeyboardArrowLeft } from '@mui/icons-material';
import ScheduleEmailComponent from './schedule_email';
import ScheduleSMSComponent from './schedule_sms';
import SMSNotificationComponent from './sms_notifications';
import { a11yProps, CustomTabPanel } from '../../pages/deals';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, Divider, Tab, Tabs } from '@mui/material';
import { fetchCalendarLinkNotificaitonThunk, fetchMeetingNotificaitonsThunk } from '../../redux/thunks/calendar';
import { settingEditNotificationFlag, settingSelectedEvent } from '../../redux/slices/calendar';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

const EditNotificationsComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [selectedTab, setSelectedTab] = useState<0 | 1>(0);
    const [schedule, setSchedule] = useState<'email' | 'phone' | null>(null);
    const { selectedEvent } = useSelector((state: RootState) => state.calendar);
    const handleChange = (event: React.SyntheticEvent, newValue: 0 | 1) => {
        setSelectedTab(newValue);
    };
    const backToEventsHandler = () => {
        dispatch(settingSelectedEvent(null));
        dispatch(settingEditNotificationFlag(false));
    };

    useEffect(() => {
        const fetchNotificaitons = async () => {
            try {
                if (selectedEvent?.type === 'link') {
                    await dispatch(fetchCalendarLinkNotificaitonThunk(selectedEvent.id as number)).unwrap();
                } else {
                    await dispatch(fetchMeetingNotificaitonsThunk(selectedEvent?.id as number)).unwrap();
                }
            } catch (e) {
                //
            }
        };
        fetchNotificaitons();
    }, [selectedEvent, dispatch]);

    if (schedule === 'email') {
        return (<ScheduleEmailComponent onCancel={(value: null) => setSchedule(value)} />);
    }
    if (schedule === 'phone') {
        return (<ScheduleSMSComponent onCancel={(value: null) => setSchedule(value)} />);
    }

    return <Box>
        <CardWrapper>
            <Button variant="text" color="secondary" onClick={backToEventsHandler}><KeyboardArrowLeft />Back to Events</Button>
            <Box padding="15px" minHeight="80vh" overflow="auto">
                <Tabs
                    value={selectedTab}
                    onChange={handleChange}
                    aria-label="notification tabs"
                >
                    <Tab
                        label="Email Notifications"
                        {...a11yProps(0)}
                    />
                    <Tab
                        label="SMS Notifications"
                        {...a11yProps(1)}
                    />
                </Tabs>
                <Divider />
                <CustomTabPanel value={selectedTab} index={0}>
                    <EmailNotificationComponent setSchedule={(value: 'email') => setSchedule(value)} />
                </CustomTabPanel>

                <CustomTabPanel value={selectedTab} index={1}>
                    <SMSNotificationComponent setSchedule={(value: 'phone') => setSchedule(value)} />
                </CustomTabPanel>
            </Box>
        </CardWrapper>
    </Box>;
};

export default EditNotificationsComponent;